import React, { useEffect, useState } from 'react';
import { hrmsStats, STAGE_LABEL } from '../../lib/hrmsApi';
import { Briefcase, Users, FileText, TrendingUp } from 'lucide-react';

const Card = ({ title, value, Icon, color }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5">
    <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${color}`}><Icon className="h-5 w-5 text-white" /></div>
    <div className="mt-3 text-3xl font-extrabold text-slate-900">{value}</div>
    <div className="text-xs text-slate-500 mt-0.5">{title}</div>
  </div>
);

const HrmsDashboard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { hrmsStats().then(setS).catch(() => setS(null)); }, []);
  if (!s) return <div className="text-slate-500 text-sm">Loading dashboard…</div>;
  return (
    <div>
      <h1 className="text-2xl font-extrabold text-slate-900">Recruitment overview</h1>
      <p className="text-sm text-slate-500 mt-1">Live pipeline stats and key numbers.</p>
      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card title="Open jobs" value={s.open_jobs} Icon={Briefcase} color="bg-orange-500" />
        <Card title="All jobs" value={s.all_jobs} Icon={FileText} color="bg-slate-900" />
        <Card title="Total applications" value={s.total_applications} Icon={TrendingUp} color="bg-blue-500" />
        <Card title="Total candidates" value={s.total_candidates} Icon={Users} color="bg-emerald-500" />
      </div>
      <h2 className="mt-10 text-lg font-bold text-slate-900">Pipeline distribution</h2>
      <div className="mt-3 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {Object.entries(s.by_stage).map(([k, v]) => (
          <div key={k} className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="text-xs uppercase tracking-widest text-slate-500">{STAGE_LABEL[k] || k}</div>
            <div className="mt-1 text-2xl font-bold text-slate-900">{v}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HrmsDashboard;
